module.exports = __webpack_public_path__ + "static/img/navbar_header_bg.d66329c7.png";